module.exports = __webpack_public_path__ + "static/media/massage.3f83467f.jpg";